import DateTimeUtils from '../../common/utils/DateTimeUtils';

export default function OfferSelectPackageRuleRenderer(targetDate, canConfigureIndependently, otherDates, operationName, locale) {
    var dayCount = otherDates.length + 1;

    return (
        <div style={{ textAlign: 'left' }}>
            <strong>{DateTimeUtils.formatFullShortDate(targetDate, locale)}</strong>
            &nbsp;is part of a {dayCount}-day package with&nbsp;
            {combineRenderedList(
                otherDates,
                (otherDate, keyIndex) => (
                    <span key={generateSpanKey(keyIndex)}>
                        <strong>{DateTimeUtils.formatFullShortDate(otherDate, locale)}</strong>
                    </span>
                ),
                (_, keyIndex) => (<span key={generateSpanKey(keyIndex)}>, </span>),
                (_, keyIndex) => (<span key={generateSpanKey(keyIndex)}> and </span>),
            )}.
            {renderClosingPhrase(targetDate, canConfigureIndependently, operationName, locale)}
        </div>
    );
}

function combineRenderedList(items, itemRender, commaRender, andRender) {
    var renderPortions = [];
    var keyIndex = 0;

    for (var itemIndex = 0; itemIndex < items.length; itemIndex++) {
        if (itemIndex > 0 && itemIndex < items.length - 1 && commaRender !== undefined)
            renderPortions.push(commaRender(items[itemIndex], keyIndex++));
        else if (itemIndex > 0 && itemIndex === items.length - 1 && commaRender !== undefined)
            renderPortions.push(andRender(items[itemIndex]));

        if (itemRender !== undefined)
            renderPortions.push(itemRender(items[itemIndex], keyIndex++));
    }

    return (
        <span>
            {renderPortions.map(portion => { return portion })}
        </span>
    )
}

function generateSpanKey(keyIndex) {
    return 'tooltipSpan' + keyIndex;
}

function renderClosingPhrase(targetDate, canConfigureIndependently, operationName, locale) {
    return canConfigureIndependently
        ? (
            <span>
                <br /><br />
                <strong>{DateTimeUtils.formatFullShortDate(targetDate, locale)}</strong> can <i>also</i> be {operationName} individually on its own.
            </span>)
        : (<span></span>);
}